const disableScrollClass = 'disable-body-scroll';
const html = document.documentElement;

export function disableBodyScroll() {
  if (html.classList.contains(disableScrollClass)) return;

  const scrollBarWidth = `${
    window.innerWidth - document.documentElement.clientWidth
  }px`;

  html.style.paddingRight = scrollBarWidth;
  html.style.setProperty('--scroll-bar-width', scrollBarWidth);
  html.classList.add(disableScrollClass);
}

export function enableBodyScroll() {
  html.classList.remove(disableScrollClass);
  html.style.setProperty('--scroll-bar-width', '');
  html.style.paddingRight = '';
}
